import React from 'react';
import { FileSearch, UserPlus, Blocks, ArrowRight } from 'lucide-react';
import { ctaCards } from '../mock/mock';

const iconMap = { FileSearch, UserPlus, Blocks };

const variantStyles = {
  primary: 'bg-white border-emerald-100 hover:border-[#00B48E]',
  secondary: 'bg-[#F0FBF7] border-emerald-100 hover:border-[#00B48E]',
  tertiary: 'bg-[#FFF7ED] border-orange-100 hover:border-orange-400',
};

const iconBgStyles = {
  primary: 'bg-emerald-100 text-[#00B48E]',
  secondary: 'bg-[#00B48E] text-white',
  tertiary: 'bg-orange-100 text-orange-600',
};

const CtaCards = () => {
  return (
    <section className="bg-white py-14 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-5">
          {ctaCards.map((c, i) => {
            const Icon = iconMap[c.icon];
            return (
              <div
                key={c.title}
                className={`group relative rounded-2xl border-2 p-7 transition-all hover:-translate-y-1 hover:shadow-xl cursor-pointer ${variantStyles[c.variant]}`}
              >
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-5 ${iconBgStyles[c.variant]}`}>
                  <Icon className="w-7 h-7" />
                </div>
                <h3 className="text-xl font-bold text-[#0F2A4B] mb-2">{c.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed mb-5 min-h-[45px]">{c.desc}</p>
                <div className="flex items-center gap-2 text-sm font-semibold text-[#00B48E] group-hover:gap-3 transition-all">
                  {c.cta} <ArrowRight className="w-4 h-4" />
                </div>
                <div className="absolute top-5 right-5 text-7xl font-black text-slate-50 select-none">{`0${i+1}`}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CtaCards;
